import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BoxTogglerService {
  boxSelector     = '.box';
  closedClass     = 'fa-chevron-up';
  collapsedClass  = 'collapsed';
  contentSelector = '.box-content';
  gridSelector    = '.grid';
  openedClass     = 'fa-chevron-down';
  togglerSelector = '#chevron';

  close ( element : JQuery, contentElement : JQuery, skipAnimation = false ) : void {
    const boxElement = this.getBoxElement(element);

    boxElement.addClass(this.collapsedClass);

    element.find(this.togglerSelector)
    .addClass(this.closedClass)
    .removeClass(this.openedClass);

    // setTimeout(() => {
      if (skipAnimation) {
        contentElement.hide();

        return;
      }

      contentElement.slideToggle(200, () => {
        contentElement.find(this.gridSelector)
        .resize();
      });
    // });
  }

  getBoxElement ( element : JQuery ) : JQuery {
    return element.closest(this.boxSelector);
  }

  getContentElement ( selector : string ) : JQuery {
    return selector
      ? angular.element(`${ this.contentSelector }${ selector }`)
      : angular.element(this.contentSelector);
  }

  open ( element : JQuery, contentElement : JQuery, skipAnimation = false ) : void {
    const boxElement = this.getBoxElement(element);

    boxElement.removeClass(this.collapsedClass);

    element.find(this.togglerSelector)
    .addClass(this.openedClass)
    .removeClass(this.closedClass);

    // setTimeout(() => {
      if (skipAnimation) {
        contentElement.show();

        return;
      }

      contentElement.slideToggle(200, () => {
        contentElement.find(this.gridSelector)
        .resize();
      });
    // });
  }
}
